import Util from '../../common/js/util.js';
import config from '../../config/config.js';
import Common from '../../common/js/common.js';
import {Request} from "../../common/request";
import store from '@/vuex/index.js';
import Vue from 'vue'
import qs from 'qs'

function wxUrl(){
    var scope = (Util.getUrlParams('join') == 1) ? 'snsapi_base' : 'snsapi_userinfo';  // snsapi_base
    const searchJson = Util.getSearchJson()
    delete searchJson.code
    delete searchJson.state
    delete searchJson.force
    let callbackUrl = window.location.origin + window.location.pathname + '?' + qs.stringify(searchJson) + window.location.hash
    var url='https://open.weixin.qq.com/connect/oauth2/authorize?appid='+ store.getters.AuthConfig.get('authAppid') +'&redirect_uri='+encodeURIComponent(callbackUrl)+'&response_type=code&scope='+ scope +'&state=STATE%23wechat_redirect&connect_redirect=1#wechat_redirect';
    window.location.replace(url)
}

function getWxCode(){
    if ( Common.isWeiXin ) {         //如果是微信
        var weixin_code = Util.getUrlParams('code');
        if ( !weixin_code ) {
            wxUrl();
        }else{
            return weixin_code;
        }
    }
}

// 获取字典
const getDicInfoByKey = obj => Request('Common/Common/getDicInfoByKey', 'GET', obj)

export default{
  wxLogin(){
    return new Promise((res, rej) => {
      var wxCode = getWxCode()
      if ( !wxCode ) { return rej(false) }

      Vue.$vux.loading.show({
        text: '正在登录'
      })
      Request('User/User/login', 'POST', {
        Code: wxCode
      }).then(data => {
        Vue.$vux.loading.hide()
        if (data.Status === 200) {
          Util.setItem(data.Result)
          store.dispatch('setUserInfo', data.Result)
          res(true)
        } else {
          if (data.Status === 202) {
            Util.removeItem()
            let search = window.location.search
            const index = search.indexOf('?')
            index === 0 && (search = search.substring(1))
            const searchJson = qs.parse(search)
            delete searchJson.code
            delete searchJson.state
            window.location.replace(window.location.origin + window.location.pathname + '?' + qs.stringify(searchJson))
            return
          }
          Vue.$vux.toast.show({
            type: 'text',
            text: '授权登录失败'
          })
        }
      }).catch(() => {
        Vue.$vux.loading.hide()
      })
    })
  },
  getDicInfoByKey
}



// WEBPACK FOOTER //
// ./src/api/global/index.js